{
  "manage": {
    "title": "Gérer les formulaires"
  },
  "workflows": {
    "add_to_list": {
      "list_name_label": "Nom de la liste"
    },
    "follow_up_campaign": {
      "campaign_name_label": "Nom de la campagne"
    },
    "validation": {
      "list_required": "Veuillez choisir une liste",
      "campaign_required": "Veuillez choisir une campagne"
    }
  },
  "settings": {
    "theme": "Thème",
    "default_confirmation_page": "Page de confirmation par défaut",
    "waitlist": "Liste d'attente",
    "expiry_date": "Date d'expiration",
    "log_key_activities": "Enregistrer les activités clés",
    "set_consent_status": "Définir le statut de consentement comme donné",
    "include_default_footer": "Inclure le pied de page par défaut",
    "key_activity": {
      "type_label": "Type",
      "create_activity_label": "Créer une activité",
      "validation": {
        "activity_type_required": "Veuillez choisir un type d'activité",
        "activity_title_required": "Veuillez choisir une activité"
      }
    },
    "theme_settings": {
      "include_default_footer_label": "Inclure le pied de page par défaut",
      "enable_recaptcha_label": "Activer reCAPTCHA"
    },
    "success_message": "Succès ! Vos modifications ont été enregistrées."
  },
  "fields": {
    "input_label": "Libellé de saisie",
    "description_optional": "Description du champ (Optionnel)",
    "default_values": "Valeurs par défaut",
    "display_view": "Vue d'affichage",
    "required": "Requis",
    "hide_field": "Masquer le champ",
    "content": "Contenu",
    "message": "Message",
    "activity": "Activité",
    "description": "Description",
    "to": "À",
    "value": "Valeur",
    "field": "Champ",
    "select_field": "Sélectionner un champ",
    "field_required": "Veuillez sélectionner un champ",
    "form_elements": {
      "elements_title": "Éléments",
      "fields_title": "Champs",
      "add_field_button": "Ajouter un champ",
      "text_field": "Texte"
    },
    "default_fields": {
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "twitter": "Twitter",
      "first_name_label": "Entrez votre prénom",
      "first_name_placeholder": "Tapez ici...",
      "last_name_label": "Entrez votre nom de famille",
      "last_name_placeholder": "Tapez ici...",
      "job_title_label": "Entrez votre titre de poste",
      "job_title_placeholder": "Tapez ici...",
      "linkedin_url_label": "Entrez votre URL LinkedIn",
      "linkedin_url_placeholder": "Tapez ici...",
      "twitter_url_label": "Entrez votre URL Twitter",
      "twitter_url_placeholder": "Tapez ici...",
      "street_address_label": "Entrez votre adresse",
      "street_address_placeholder": "Tapez ici...",
      "city_label": "Entrez votre ville",
      "city_placeholder": "Tapez ici...",
      "country_label": "Entrez votre pays",
      "country_placeholder": "Tapez ici...",
      "zip_label": "Entrez votre code postal",
      "zip_placeholder": "Tapez ici...",
      "state_label": "Entrez votre état/province",
      "state_placeholder": "Tapez ici...",
      "consent_label": "J'accepte de recevoir des communications marketing et je comprends que je peux me désabonner à tout moment."
    },
    "required_label": "Requis",
    "email_required_tooltip": "Le courriel est requis comme identifiant dans les systèmes.",
    "more_actions": "Plus d'actions",
    "more_actions_aria": "plus d'actions",
    "form_element_aria": "élément de formulaire",
    "edit_details": "Modifier les détails",
    "description_label": "Description",
    "description_placeholder": "Tapez ici ...",
    "drag_drop_instruction": "Glissez et déposez le champ ici pour remplir le formulaire",
    "remove_field_confirmation": "Êtes-vous sûr de vouloir supprimer ce champ ?",
    "remove_field_title": "Supprimer le champ de formulaire",
    "remove_field_aria": "supprimer le champ de formulaire",
    "title_label": "Titre"
  },
  "tabs": {
    "fields": "Champs",
    "settings": "Paramètres"
  },
  "placeholders": {
    "type_label": "Saisir le libellé",
    "input_information": "Saisir les informations pour remplir les champs",
    "type_default_values": "Saisir les valeurs par défaut",
    "type_activity_title": "saisir le titre de l'activité",
    "type_activity_description": "saisir la description de l'activité",
    "enter_text_content": "Saisir le contenu du texte",
    "type_here": "Tapez ici..."
  },
  "display_options": {
    "dropdown": "Liste déroulante",
    "list": "Liste"
  },
  "workflow": {
    "add_conditions": "Ajouter des conditions",
    "remove_workflow": "Supprimer le workflow",
    "actions": "Actions",
    "confirm_remove_title": "Supprimer le workflow",
    "confirm_remove_content": "Êtes-vous sûr de vouloir supprimer ce workflow ?",
    "add_workflow_button": "+ Ajouter un workflow",
    "save_cancel_tooltip": "Veuillez d'abord enregistrer ou annuler vos modifications actuelles",
    "add_condition_button": "Ajouter une condition",
    "condition_modal_title": "Condition",
    "condition_modal_caption": "Effectuer l'action uniquement lorsque cette condition est remplie.",
    "field_selection_error": "Veuillez sélectionner un champ",
    "value_selection_error": "Veuillez sélectionner une valeur"
  },
  "text_element": "Texte",
  "text_element_placeholder": "Remplacez par votre texte",
  "forms": {
    "confirmation": {
      "thank_you": "Merci",
      "default_message": "Merci d'avoir soumis le formulaire. Vos informations ont été reçues avec succès.",
      "redirect_message": "Vous êtes redirigé vers",
      "nexl_branding": "Ce formulaire a été créé avec Nexl. Explorez",
      "learn_more": "pour en savoir plus",
      "header_label": "En-tête",
      "header_placeholder": "Tapez l'en-tête",
      "message_label": "Message",
      "message_placeholder": "Tapez le message",
      "redirect_link_label": "Lien de redirection",
      "redirect_link_placeholder": "Collez le lien de votre site web ici."
    },
    "waitlist": {
      "settings": {
        "description": "Ajustez les paramètres de votre liste d'attente, y compris les conditions et l'URL de redirection",
        "enable_label": "Activer la liste d'attente",
        "redirect_url_label": "URL de redirection",
        "redirect_url_placeholder": "Collez l'URL ici"
      },
      "condition": {
        "label": "Condition",
        "add_button": "Ajouter une condition",
        "modal_title": "Condition",
        "modal_caption": "Effectuer l'action uniquement lorsque cette condition est remplie.",
        "rollup_field_label": "Champ de cumul",
        "no_rollup_field_option": "Aucun cumul n'est lié à cette liste",
        "operation_label": "Opération",
        "value_label": "Valeur",
        "operation_value_label_greater_than_or_equal_to": "est supérieur ou égal à",
        "operation_value_label_is": "est",
        "rollup_field_tooltip": "Le champ de cumul est requis pour utiliser la fonctionnalité de liste d'attente. Vous pouvez en créer un via le menu d'actions du Workspace."
      },
      "validation": {
        "redirect_url_invalid": "Veuillez saisir une URL valide",
        "redirect_url_required": "L'URL de redirection est requise",
        "value_number_required": "Veuillez saisir un nombre",
        "value_integer_required": "La valeur doit être un entier",
        "value_positive_required": "La valeur doit être supérieure à 0",
        "value_required": "Veuillez saisir une valeur",
        "condition_required": "Veuillez ajouter une condition"
      }
    }
  },
  "cover_photo": {
    "title": "Photo de couverture",
    "add_button": "Ajouter une photo de couverture",
    "upload_placeholder": "Glissez et déposez l'image ou cliquez ici pour télécharger.\n          Format accepté : JPEG, PNG. Taille maximale : 50 Mo. Ratio d'aspect : 5:1 (par ex. 3000 x 600 px)",
    "delete_confirmation": "Cliquez sur confirmer pour supprimer la photo de couverture"
  },
  "publish": {
    "button": "Publier",
    "preview_button": "Aperçu",
    "embed_title": "Intégrer le formulaire",
    "link_title": "Lien",
    "download_qr": "Télécharger le QR"
  },
  "status": {
    "saving_changes": "Sauvegarde des modifications. Veuillez patienter...",
    "unsaved_warning": "Vos modifications n'ont pas encore été sauvegardées. Cliquez sur \"Enregistrer\" pour sauvegarder vos modifications."
  }
}
